export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const INCREASE_QTY = "INCREASE_QTY";
export const DECREASE_QTY = "DECREASE_QTY";
export const ADD_LOADER = "ADD_LOADER"
export const REMOVE_LOADER = "REMOVE_LOADER"
export const MOVE_TO_CART = "MOVE_TO_CART"
export const TOGGLE_TOAST = "TOGGLE_TOAST"
export const MOVE_TO_WISHLIST = "MOVE_TO_WISHLIST"
export const HIGH_TO_LOW = 'HIGH_TO_LOW'
export const LOW_TO_HIGH = 'LOW_TO_HIGH'
export const FILL_CART = "FILL_CART"
export const FILL_WISHLIST = "FILL_WISHLIST"
export const INSTOCK_TOGGLE = "INSTOCK_TOGGLE"
export const FAST_DELIVERY = "FAST_DELIVERY"

